import { useToggle } from '@hn-front/utils';
var ALLOWED_INVITE_MODES = [
    'grade2ExceptA',
    'grade2ExceptB',
    'grade2A',
    'grade2B',
];
var useInviteColleagues = function (mode) {
    var _a = useToggle(true), isInviteColleaguesModalOpen = _a.isToggled, toggleInviteColleaguesModal = _a.toggle;
    return {
        modalEnabled: ALLOWED_INVITE_MODES.includes(mode),
        isInviteColleaguesModalOpen: isInviteColleaguesModalOpen,
        toggleInviteColleaguesModal: toggleInviteColleaguesModal,
    };
};
export { useInviteColleagues };
